import { render } from "./ModalTopUpCredit.vue?vue&type=template&id=23101ca4&scoped=true"
import script from "./ModalTopUpCredit.vue?vue&type=script&lang=js"
export * from "./ModalTopUpCredit.vue?vue&type=script&lang=js"

import "./ModalTopUpCredit.vue?vue&type=style&index=0&id=23101ca4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23101ca4"]])

export default __exports__